import { createTheme } from "@mui/material/styles";
import { CustomTypography } from "./typography";
import { CustomPalette } from "./palette";
import cardOverrides from "./cardOverrides";
import dialogOverrides from "./dialogOverrides";
import tableOverrides from "./tableOverrides";
import buttonOverrides from "./buttonOverrides";
import listOverrides from "./listOverrides";
import chipOverrides from "./chipOverrides";
import alertOverrides from "./alertOverrides";
import "./theme.scss";

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    transparent: true;
  }
}

export default createTheme({
  palette: CustomPalette,
  typography: CustomTypography,
  components: {
    ...cardOverrides,
    ...dialogOverrides,
    ...tableOverrides,
    ...buttonOverrides,
    ...listOverrides,
    ...chipOverrides,
    ...alertOverrides
  },
});
